import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { CategoryPicker, CategoryPickerProps } from './CategoryPicker';
import { getCategoryFilter } from './use-category-class';

const filter = getCategoryFilter(Entities.customer);

type CustomerCategoryPickerProps = Omit<CategoryPickerProps, 'filter'>;

export function CustomerCategoryPicker(props: CustomerCategoryPickerProps) {
  return <CategoryPicker {...props} filter={filter} />;
}
